// Global event delegation – virker selv når elementer udskiftes via AJAX
document.addEventListener("click", (e) => {
  const plus = e.target.closest(".qty-btn.plus");
  const minus = e.target.closest(".qty-btn.minus");

  if (plus) {
    const wrapper = plus.closest(".quantity-selector");
    if (!wrapper) return;

    const input = wrapper.querySelector(".qty-input");
    if (!input) return;

    let val = parseInt(input.value) || 1;
    input.value = val + 1;
  }

  if (minus) {
    const wrapper = minus.closest(".quantity-selector");
    if (!wrapper) return;

    const input = wrapper.querySelector(".qty-input");
    if (!input) return;

    let val = parseInt(input.value) || 1;
    if (val > 1) input.value = val - 1;
  }
});
